import { useState, useEffect } from "react";
import "./LoginForm.css";
import InputTextField from "../InputText/InputText";
import { AiFillEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { baseurl } from "../BaseUrl/Baseurl";
import ButtonLink from "../ButtonLink/ButtonLink";
import axios from "axios";
import { setLoginDetails as setLoginDetailsAction } from "../../store/userDetails"; // NEW

function Login() {
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [emailerror, setEmailerror] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [passworderror, setPassworderror] = useState("");
  const [successstatus, setSuccessstatus] = useState("");
  const [loginDetails, setLoginDetails] = useState(null);
  const [role, setRole] = useState("");
  const [errormsg, setErrormsg] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    if (successstatus && loginDetails) {
      dispatch(
        setLoginDetailsAction(loginDetails, { Pagename: "Admin_Console" }), // CHANGED
      );
    }
  }, [successstatus, loginDetails]);

  const togglePasswordVisiblity = (event) => {
    setIsPasswordShown(!isPasswordShown);
    event.preventDefault();
  };
  function onpasswordChange(e) {
    setPassword(e.target.value.replace(/\s+/g, ""));
    validateField(e.target.name, e.target.value);
  }
  function onemailChange(e) {
    setEmail(e.target.value);
    validateField(e.target.name, e.target.value);
  }

  const strongRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{6,})/;

  const validateField = (fieldName, value) => {
    if (fieldName === "password") {
      let passwordValid = value != "" && value.match(strongRegex);

      setPasswordValid(passwordValid);

      if (passwordValid === null || passwordValid === undefined) {
        setPassworderror(
          "Password should be at least 6 characters and include lowercase, uppercase, numeric, and special characters.",
        );
        setPasswordValid(false);
      } else {
        setPassworderror("");
        setPasswordValid(true);
      }
    }

    if (fieldName === "email") {
      if (value.length == 0) {
        setEmailerror("Please Enter your valid Username");
        setEmailValid(false);
      } else {
        setEmailerror("");
        setEmailValid(true);
      }
    }
  };

  const logout = (uid, tokenid) => {
    axios({
      method: "PUT",
      url: baseurl + "/api/logout?userId=" + uid,

      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + tokenid,
      },
    })
      .then((response) => { })
      .catch((error) => {
        console.error(error);
      });
    localStorage.clear();
    sessionStorage.clear();
  };

  function onSubmitEvent(event) {
    event.preventDefault();
    setErrormsg("");

    if (emailValid && passwordValid) {
      let formData = new FormData();
      formData.append("username", email);
      formData.append("password", password);

      axios({
        method: "POST",

        url: baseurl + "/api/login",
        formData,

        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then((response) => {
          const data = response.data;

          if (
            data?.role &&
            data.role?.toString().toLowerCase() !== "admin"
          ) {
            setErrormsg("Unauthorised User !!");
            logout(data?.userId, data?.token);
          } else {
            sessionStorage.setItem("adminConsoleActiveTab", "Master Tab");
            setRole(data.role);
            setLoginDetails(data);
            setSuccessstatus(true);
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.message);
          setErrormsg(error.response.data.message);
        });
    }
  }

  return (
    <div className="">
      {successstatus && (
        <ButtonLink
          btnPath={
            /* istanbul ignore next -- role can only be de/admin after a successful login */
            role === "AE" ? "/Project" : "/AdminConsole"
          }
        />
      )}

      <div className="row ">
        <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 ">
          <div className="trialformtext">
            <center>
              <b>Login into account </b>
            </center>
          </div>
          <p>
            <center>use your credentials to access your account</center>
          </p>

          <form className="row py-3">
            <div className="col-12 mb-2">
              <center>
                <InputTextField
                  handleInputChange={onemailChange}
                  valueText={email}
                  inputName="email"
                  inputId="email"
                  classname="login-box3"
                  inputType="text"
                  placeholderValue="Username"
                  PreventEnter={
                    /* istanbul ignore next -- InputTextField does not consume this prop */
                    (e) => {
                      e.key === "Enter" && e.preventDefault();
                    }
                  }
                ></InputTextField>
              </center>

              <div className="login-error fsi-14">{emailerror}</div>
            </div>
            <div className="col-12 mb-3">
              <center>
                <InputTextField
                  handleInputChange={onpasswordChange}
                  valueText={password}
                  inputName="password"
                  inputId="password"
                  classname="login-box3"
                  maxLen={16}
                  placeholderValue="Password"
                  inputType={isPasswordShown ? "text" : "password"}
                  PreventEnter={
                    /* istanbul ignore next -- InputTextField does not consume this prop */
                    (e) => {
                      e.key === "Enter" && e.preventDefault();
                    }
                  }
                ></InputTextField>
              </center>

              {isPasswordShown ? (
                <AiFillEye
                  className="eye-style"
                  onClick={togglePasswordVisiblity}
                  size={20}
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="eye-style"
                  onClick={togglePasswordVisiblity}
                  size={20}
                />
              )}
              <div className="login-error fsi-14">{passworderror}</div>
            </div>

            {errormsg.length != 0 && (
              <div className=" text-center col-12">
                <center>
                  <p className="login-error fsi-14 mb-0 p-1">{errormsg}</p>
                </center>
              </div>
            )}

            <div className="col-12">
              <center>
                <button
                  type="submit"
                  className="login-btn3 w-75 text-nowrap"
                  name="submit"
                  onClick={onSubmitEvent}
                >
                  <b>LOGIN TO YOUR ACCOUNT</b>
                </button>
              </center>{" "}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;